/* eslint-disable max-len */
export default {
  // COMMON
  notUse: 'Disabled',
  use: 'Enabled',
  dashboard: 'Dashboard',
  profile: 'Member Info',
  administratorsSettings: 'Admin Settings',
  mfaSetting: 'MFA Settings',
  registrationManagement: 'Registration Info Management',
  outgoingPhone: 'Sender Number Management',
  kakaoProfile: 'Kakao Profile Management',
  rejectPhone: 'Opt-out Number Management',
  unsubscribeCustomer: 'Manage Unsubscribe Customers',
  departmentInformation: 'Department Info Management',
  userMenu: 'User Menu',
  charge: 'Billing',
  messageUsage: 'Message Usage Status',
  kakaoTemplate: 'AlimTalk Template Management',
  images: 'Image Management',
  solutionGuide: 'Solution Guide',
  langSelect: 'Language Selection',
  messageType: 'Message Type',
  companyName: 'Company Name: I2MAX',
  companyCeo: 'CEO: Geunmo Kim',
  companyBusinessNumber: 'Business Registration Number: 120-86-47303',
  companyAddr: 'Headquarters Address: 137 Mapo-daero, Mapo-gu, Seoul, KPX Building, 04143',
  companyNumber: 'Main Contact: 02-365-2187',
  companyFax: 'Fax: 02-365-2093',
  terms: 'Terms of Service',
  privacy: 'Consent to Collection and Use of Personal Information',
  noList: 'No Items',
  noListMsg: 'There are currently no items available.',
  total: 'Total',
  count: 'items',
  suffixCount: 'items',
  list: 'List',
  unit: 'Item(s)',
  confirmBtn: 'Confirm',
  deleteBtn: 'Delete',
  clostBtn: 'Close Button',
  clearBtn: 'Remove',
  applyState: 'Application Status',
  applyYes: 'Apply',
  applyNo: 'Not Applied',
  regsiterBtn: 'Submit',
  selected: 'Please select.',
  entered: 'Please enter.',
  calendarIcon: 'Calendar Icon',
  searchBtn: 'Search',
  searchToday: 'Today',
  searchWeek: '1 Week',
  searchMonth: '1 Month',
  searchMonth3: '3 Months',
  searchYear: '1 Year',
  languageSelect: 'Language Selection',
  korean: 'Korean',
  english: 'English',
  downloadOfSearchResults: 'Download Search Results',
  currentConditions: 'Do you want to download the search results for the current filters?',
  resettingPassword: 'Reset Password',
  won: 'Won',
  tail: 'More View',
  administrators: 'Admin List',

  globalError: 'An error has occurred. Please contact the administrator.\ni2message_support@i2max.co.kr',
  mainTitle: 'i2Message Partner Web',
  subTitle: 'Messaging Agent',
  journeyExcelTitle: 'Message Usage Stats > journey',
  activityExcelTitle: 'Message Usage Stats > journey > activity',
  logout: 'logout',
  prefixCount: '',
  advert: '(Advertising)',
  advertFooter: 'To unsubscribe : Home > Block a Channel',
  reset: 'Reset',
  progressStatus: 'Progress Status :',

  messageTypes: {
    text: 'Text Message',
    friendtalk: 'AlimTalk',
    alimtalk: 'FriendTalk',
    friendtalkWideItemList: 'FriendTalk Wide Item List',
    friendtalkCommerce: 'FriendTalk Commerce',
    friendtalkCarouselFeed: 'FriendTalk Carousel Feed',
    friendtalkCarouselCommerce: 'FriendTalk Carousel Commerce',
    friendtalkPremiumVideo: 'FriendTalk Premium Video',
  },
  label: {
    all: 'All',
    notSelected: 'Unselected',
    departmentName: 'Department Name',
    findId: 'Find Username',
    id: 'ID',
    findPassword: 'Find Password',
    email: 'Email',
    login: 'Login',
    journeyNameSearch: 'Message Group',
    sendingProfile: 'Select Sending Profile',
    category: 'Category',
    strikethrough: 'Apply Strikethrough',
    addChannel: 'Add Channel',
    imageName: 'Image Name',
    activationStatus: 'Activation Status',
    activate: 'Active',
    deactivate: 'Inactive',
    templateCode: 'Template Code:',
    status: 'Status:',
    updateUser: 'Edit User',
    addUser: 'Create User',
    phoneNumber: 'Mobile Number',
    userName: 'Name',
    securitySettings: 'Security Settings',
    mfaSettings: 'MFA Settings',
    ipSettings: 'IP Settings',
    allowIP: 'Allowed IP',
    comment: 'Notes',
    templateInspection: 'Template Review',
    inquiryDetails: 'Inquiry Content',
    selectFile: 'Select File',
    addImage: 'Upload Image',
    imageType: 'Image Type',
    imageList: 'Image List',
    type: 'Ratio',
    size: 'Size',
    ratio: 'Ratio',
    created: 'Registration Date',
    rejectPhone: 'Opt-out Number',
    customerNumber: 'Customer Number',
    scheduleDownload: 'Schedule Download',
    currentPassword: 'Current Password',
    newPassword: 'New Password',
    confirmPassword: 'Confirm New Password',
    inquiryList: 'Inquiry History',
    attachment: 'Attachment',
    companyName: 'Company Name',
    ip: 'IP',
    serviceName: 'Service Name',
    ARSNumber: 'ARS Number',
    userList: 'User List',
  },
  comment: {
    inquiry: [
      'Send Money button',
      'To get the template approved,',
      'a screenshot of the payment page that shows the payment provider',
      'must be attached.',
      'In the scheme_android and scheme_ios fields of the app link button,',
      'use the scheme in the format: alimtalk=kakaopay://money/to/bank?',
      'If you enter the scheme in this format,',
      'you can register the "Send Money" button.',
      'For more details,',
      'refer to the Kakao guide',
      'for reference.',
    ],
    inquiryDetails: [
      'Inquiry (up to 300 characters) + File',
      'Attached files (up to 10)',
      '- Supported file types: .png, .jpg, .jpeg, .gif, .pdf, .hwp, .doc, .docx',
      '- Maximum size per file: 5MB',
      '- Maximum total upload size: 50MB',
    ],
    scheduleDownload: `- Files older than one day will expire.
- Up to 5 items can be in 'In Progress' status.`,
    resettingPassword: `- The password set at first login is temporary.

    - You will need to change it later for continued use.
    
    Passwords must be 8-100 characters and include
    uppercase/lowercase letters, numbers, and special characters.`,
    updateUser: [
      '- Up to 5 IP addresses can be allowed.',
      '- Only Korean mobile carrier numbers are allowed.',
    ],
    addUser: [
      '- Up to 5 IP addresses can be allowed.',
      '- A temporary password will be issued when creating a user.',
      '- Only Korean mobile carrier numbers are allowed.',
    ],
    templateInspection: [
      '- To submit the template for review, please click the \'Request Review\' button.',
      '- To register a template-related inquiry, please click the \'Submit Inquiry\' button.',
    ],
    alimTalkTemplate: {
      button: 'Template Guidelines',
      title: 'Please make sure to check the guidelines.',
      content: [
        'Templates with status "Review Requested", "Under Review", or "Approved" cannot be edited or deleted.',
        '(Please register a new template if changes are needed.)',
        'Templates in "Draft" status can be edited from the list view.',
        'Templates in "Draft" status must be submitted for review from the list screen to be properly reviewed by Kakao.',
      ],
    },
    image: {
      select: 'Select the message type and image type to register.',
      messageType: 'Image specifications vary by message type, and changing the type will reset the uploaded image.',
      preview: 'Only images that meet the required specifications can be uploaded. You can preview the image after selection.',
      mms: '* MMS Image :',
      mmsExtension: '- File format: JPG, JPEG',
      mmsSize: '- Size/Dimensions: Up to 300KB / Recommended: 1000x1000',
      normal: '* FriendTalk Standard Image :',
      kakaoExtension: '- File format: JPG, PNG',
      normalSize: '- Size/Dimensions: Up to 500KB / Recommended: 800x400 (2:1 ratio), 800x800 (1:1 ratio), 800x600 (4:3 ratio)',
      wide: '* FriendTalk Wide Image :',
      wideSize: '- Size/Dimensions: Up to 5MB / Recommended: 800x600 (4:3 ratio)',
      kakaoCopyright: 'Unauthorized use of Kakao\'s logos, trademarks, service names, or copyrighted materials, or violation of message content guidelines for informational (AlimTalk) or promotional (FriendTalk) messages, may result in restricted access to Kakao Channel services.',
      wideItemList: '* FriendTalk Wide Item List Image :',
      wideItemListSize: '- Size/Dimensions: Up to 5MB / Recommended: 800x400 (2:1 ratio)',
      alimtalk: '* Alimtalk Standard Image :',
      alimtalkSize: '- Size/Dimensions: Up to 500KB / Recommended: 800x400 (2:1 ratio)',
      alimtalkHighlight: '* Alimtalk Highlight Thumbnail Image :',
      alimtalkHighlightSize: '- Size/Dimensions: Up to 500KB / Recommended: Up to width 108px (1:1 ratio)',
      carouselFeed: '* KakaoTalk Carousel Feed Image:',
      carouselFeedSize: '- File Size/Dimensions: Under 5MB / Recommended: 800x400 (2:1 ratio), 800x600 (4:3 ratio)',
      carouselCommerce: '* KakaoTalk Carousel Feed Image:',
      carouselCommerceSize: '- File Size/Dimensions: Under 5MB / Recommended: 800x400 (2:1), 800x800 (1:1), 800x600 (4:3)',
    },
  },
  status: {
    apply: 'Apply',
    notApplied: 'Not Applied',
    registered: 'Submit',
    requested: 'Request',
    reviewing: 'In Progress',
    approved: 'Approve',
    rejected: 'Reject',
    realTime: 'Live',
    contractExpiration: 'Contract Expired',
    lock: 'Locked',
    notSent: 'Not Sent',
    passwordError5: 'Password Entered Incorrectly 5 Times',
    sent: 'Sent',
    temporaryPassword: 'Temporary Password Issued',
    notApproved: 'Not Approved',
    normal: 'Normal',
    abnormal: 'Abnormal',
    rejection: 'Rejected',
    noRejection: 'Not Rejected',
  },
  head: {
    comment: 'Notes',
    phoneNumber: 'Mobile Number',
    email: 'Email',
    userEmail: 'User Email',
    id: 'ID',
    ip: 'IP Address',
    enabled: 'Activation Status',
    update: 'Edit',
    imageName: 'Image Name',
    imageType: 'Image Type',
    imageSize: 'Image Size',
    imageRatio: 'Image Ratio',
    imageThumbnail: 'Image Thumbnail',
    image: 'Image',
    content: 'Content',
    fileId: 'File ID',
    requestPath: 'Request Path',
    requestedTime: 'Request Date & Time',
    status: 'Status',
    loginIp: 'Login IP',
    lastLogin: 'Last Login',
    createdAt: 'Registration Date/Time',
  },
  button: {
    addUser: 'Create User',
    update: 'Edit',
    selectDelete: 'Delete Selected',
    ok: 'Confirm',
    terms: 'Terms of Use',
    privacyPolicy: 'Privacy Policy',
    load: 'Import',
    register: 'Register',
    delete: 'Delete',
    addImage: 'Add Image',
    viewLarger: 'View Larger',
    download: 'Download',
    scheduledFileDownload: 'Download Scheduled File',
    scheduleDownloadOfSearchResults: 'Download Search Results',
    add: 'Add',
    resetPassword: 'Reset Password',
    registerInquiry: 'Submit Inquiry',
    inspectionRequest: 'Request Review',
    regist: 'Submit',
    addButton: 'Add',
    viewLargerImage: 'View Image (Full Size)',
    refresh: 'Refresh',
    cancel: 'Cancel',
    applicationExample: 'View Example of Application',
  },
  placeholder: {
    file: 'No File Selected',
    search: 'Please enter a keyword.',
    password: 'Please enter your password.',
    confirmPassword: 'Please confirm your new password.',
    inquiryDetails: 'Please enter your inquiry for the reviewer.\nTemplates in Requested or Approved status cannot be inquired.',
  },
  alert: {
    expired: {
      title: 'Authentication info has expired.',
      content: 'Redirecting to the login page.',
    },
    needLogin: {
      title: 'Login is required to use this service.',
      content: 'Redirecting to the login page.',
    },
    findId: {
      content: 'Username has been sent via email. Please check your email for confirmation.',
    },
    resetPassword: {
      title: 'Password reset complete.',
      content: `A temporary password has been issued.
        Please check your SMS or email and log in.
        * You must change the temporary password upon first login.`,
    },
    success: {
      content: 'Registration Complete',
    },
    deleteSuccess: {
      content: 'Deletion Complete',
    },
    userSecurity: {
      title: 'Notification',
      content: 'Security setting is required.',
    },
    resetPasswordSuccess: {
      title: 'Password reset complete.',
      content: `A temporary password has been issued.
        Please check your SMS or email and log in.
        * You must change the temporary password upon first login.`,
    },
    addIp: {
      title: 'Notification',
      content: 'Up to 5 IP addresses can be allowed.',
    },
    requestSuccess: {
      content: 'Review Request Completed',
    },
    addUser: `User creation completed successfully.
    A temporary password has been sent to the email address.'
    `,
    completed: 'Completed',
    applicationExample: {
      title: 'Example of Company/Service Name Application',
      imageAlt: 'Example of Message Display',
      content: 'This is the sender name displayed on the first line of promotional text messages.',
    },
  },
  hint: {
    phoneNumber: '※ Only Korean carrier numbers can be entered.',
  },
  confirm: {
    leave: {
      title: 'Are you sure you want to leave this site?',
      content: 'Changes you made may not be saved.',
    },
  },
  couponType: {
    numberDiscount: 'OO won discount coupon',
    percentDiscount: 'OO% discount coupon',
    deliveryDiscount: 'a discount coupon for shipping costs',
    freeCoupon: 'OO Free Coupons',
    upCoupon: 'OO UP coupon',
  },
  tooltip: {
    securityTemplate: [
      'Secure Template Status',
      'Enable this option for security messages such as OTP.',
      'The message text will not be displayed on any devices except the primary device at the time of sending.',
      'If the template\'s security status does not comply with Kakao guidelines, it may be automatically adjusted during the review process.',
    ],
    itemHighlight: [
      'When registering an item highlight, an image is not required. However, if you choose to upload one, both a title and description must be provided.',
      'If an image is added, the maximum length for the title is limited to 21 characters and the description to 13 characters.',
      'You can use variables in the title and description. Variables must be entered in the format #{variable} without spaces.',
    ],
    itemList: [
      'The item list must contain between 2 and 10 items.',
      'Variables can be used in item content and must be written in the format #{variable} without spaces.',
      'When using an item list, the total number of characters, including the template content and additional information, is limited to 700 characters.',
    ],
    content: [
      'Up to 1,000 characters, including #{variable} and URLs, can be entered without distinction between Korean and English.',
      'Variables must be entered in the format #{variable} without spaces.',
      'When using additional information, the total character count, including the template content and additional information, is limited to 1,000 characters.',
      'When using an item list, the total character count, including the template content and additional information, is limited to 700 characters.',
    ],
    additionalInformation: [
      'Additional information can be up to 500 characters long and may include a URL. (Variables cannot be used.',
      'When using additional information, the total character count, including the template content, is limited to 1,000 characters.',
      'If promotional text is included, #{variable} and URLs cannot be used.',
    ],
    button: [
      'Up to 5 buttons can be added.',
      '#{variable} can only be used in button links.',
      'Web links must include [http://, https://] and can be up to 500 characters long.',
      '(Example : https://#{home}/#{id} -> http://www.home.com/12345)',
      '- Delivery Tracking: Parses the courier company and tracking number from the message and automatically generates a [Track Delivery] button linking to the Kakao search delivery tracking page.',
      '- Web Link : Opens a web page in the in-app browser when the button is clicked.',
      '- App Link : Launches an app custom scheme when the button is clicked.',
    ],
    buttonName: 'Variables are not allowed',
    buttonLink: 'variables allowed',
    meesageGroup: `<b>Message Group Name Guide</b>
    <b>- Marketing Cloud :</b> Enter the Journey name.
    <b>- Sales Cloud :</b> Enter one of the following: Object name, Campaign name, or Flow name.

    <b>Message ID Guide</b>
    The Message ID is generated by combining the elements below.
    You can search using either the full ID or just a partial value.

    <b>- Marketing Cloud:</b>
      JourneyName & JourneyVersion & ActivityName & ActivityId
    <b>- Sales Cloud - Object:</b>
      ObjectName & RecordLabel & RecordId
    <b>- Sales Cloud - Campaign:</b>
      Campaign & CampaignRecordLabel & CampaignRecordId & SettingId
    <b>- Sales Cloud - Flow:</b>
      Flow & FlowRecordLabel & FlowId & FlowVersion & ElementId & SourceRecordId

    <b>Example:</b> WelcomeJourney & v1 & SendMessage & 1234-abc
      → You can search with partial values such as WelcomeJourney or SendMessage & 1234.
    `,
  },
};
